/**
 * Utilitário universal para obter a URL base da API do Aesir ERP.
 * Garante fallback seguro para https://api.aesirerp.com/api mesmo que a variável de ambiente não esteja injetada.
 */
export function getApiBaseUrl(): string {
    if (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_API_URL) {
        return process.env.NEXT_PUBLIC_API_URL.replace(/\/+$/, '');
    }
    return 'https://api.aesirerp.com/api';
}
